module.exports = __webpack_public_path__ + "img/ring_g_s_0_null@2x.e1762aca.png";